/* eslint-disable no-param-reassign */
/**
 * @file Axios Interceptors
 */
import { capitalize } from '@seiue/util';
/**
 * Inject request headers like Authorization and x-school-id
 *
 * @param root0 - 参数
 * @param root0.axios - 需要被注入 request headers 的 axios 实例
 * @param root0.getOAuthInfo - 用于获取 OAuth 数据
 * @param root0.getReflection - 用于获取 Reflection 数据
 * @internal
 */
export const injectRequestHeaders = ({ axios: ax, getOAuthInfo, getReflection, }) => {
    ax.interceptors.request.use(async (config) => {
        config.headers = config.headers || {};
        if (!config.omitAuthorizationHeader && getOAuthInfo) {
            const oAuthToken = await getOAuthInfo();
            if (oAuthToken) {
                config.headers.Authorization = `${capitalize(oAuthToken.tokenType)} ${oAuthToken.accessToken}`;
            }
        }
        if (!config.omitReflectionHeaders && getReflection) {
            const reflection = await getReflection();
            if (reflection) {
                config.headers['X-Reflection-Id'] = reflection.id;
                config.headers['X-Role'] = reflection.role;
                config.headers['X-School-Id'] = reflection.schoolId;
            }
        }
        return config;
    });
};
/**
 * Resolve x-pagination headers and return by response
 *
 * @param root0 - 参数
 * @param root0.axios - axios 实例
 * @internal
 */
export const resolveResponseHeaders = ({ axios: ax, }) => {
    ax.interceptors.response.use(response => {
        const parsed = Object.assign(Object.assign({}, response), { pagination: null });
        const { headers } = response;
        if (headers && headers['x-pagination-total-count'] != null) {
            parsed.pagination = {
                totalCount: +headers['x-pagination-total-count'],
                currentPage: +headers['x-pagination-current-page'],
                perPage: +headers['x-pagination-per-page'],
                pageCount: +headers['x-pagination-page-count'],
            };
        }
        return parsed;
    });
};
//# sourceMappingURL=data:application/json;base64,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